export default __webpack_public_path__ + "static/media/werehouse.663189cd.jpg";